import { useEffect, useMemo, useState } from "react";
import GeneralTable from "../Tabellen/GeneralTable";
import DatenLaden from "../Tabellen/DatenLaden";
import { eiuHeader } from "../Tabellen/ConstTabKopf/EiuKopf";
import EiuUpdate from "./EiuUpdate";
import EiuCreate from "./EiuCreate";
import StammdatenExport from "../Stammdaten/StammdatenExport";

export default function EiuLaden({ instance }) {
    const [data, setData] = useState();
    const [columns, setColumns] = useState();

    useEffect(() => {
        instance.getEiuEisenbahninfraunternehmenGet((error, data) => {
            if (error) {
                console.log(error);
            } else {
                setData(data);
                setColumns(eiuHeader);
            }
        });
    }, [instance])

    const reloadData = () => {
        setData();
        let loading = new Promise((result) => {
            instance.getEiuEisenbahninfraunternehmenGet((error, data) => {
                if (error) {
                    console.log(error);
                } else {
                    result(data);
                }
            });
        })
        loading.then(msg => { setData(msg); })
    }

    const prepData = useMemo(() => data, [data]);
    const additionalColumn = 
    {
        id: "update",
        Header: "",
        keyword: "info",
        Cell: ({ row }) => {
            return (
            <div>
                <EiuUpdate rowEntry={row} reloadData={reloadData} instance={instance} />
            </div>
        )}
    }


    //switch to csv format
    const csvIt = loadedData => {
        return loadedData.map(it =>
        ({
            ...it,
            Eisenbahninfrastrukturunternehmen: it.eiu,
            Abkürzung: it.kurz
        }))
    }
    return (
        <div>
            <EiuCreate instance={instance} reloadData={reloadData} />
            {data && columns
                ? <div>
                    <GeneralTable data={prepData} columns={columns} hiddenColumns={['id']} additionalColumns={[additionalColumn]} />
                    <StammdatenExport csvedData={csvIt(prepData)} csvHeader={['Eisenbahninfrastrukturunternehmen', 'Abkürzung']} csvFilename={"sd_eiu"}/>
                </div>
                : <DatenLaden />}
        </div>
    );

}